import React, { useEffect, useState } from 'react'
import ChangePasswordForm from '../chagnePasswordForm/ChangePasswordForm';
import DownloadButtons from '../downloadButtons/DownloadButtons';
import { useSelector } from 'react-redux';

const AllSettings = () => {

    const user = useSelector(state => state?.AuthSlice?.user)
    const [showPass, setShowPass] = useState(false);
    const [changeCards, setChangeCards] = useState("")

    const [notification, setNotification] = useState(false);

    const handleToggle = (e) => {
        setNotification(e.target.checked);

        if (!notification) {
            // Turning ON notifications
            if (Notification.permission === "default") {
                Notification.requestPermission().then((result) => {
                    if (result === "granted") {
                        setNotification(true);
                    } else {
                        alert("Notification permission denied. Please check browser setting");
                        setNotification(false);
                    }
                });
            } else if (Notification.permission === "granted") {
                setNotification(true);
            } else {
                alert("Notification permission denied. Please check browser setting");
                setNotification(false);
            }
        } else {
            // Turning OFF notifications
            setNotification(false);
        }

    };


    useEffect(() => {
        if (Notification.permission === "granted") {
            setNotification(true)
        }
    }, [])

    const passwordHideShow = () => {
        setShowPass(!showPass);
    }


    return (
        <>
            <div className="sample-settings mt-4">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="sample-setting-box">
                                <ul className='setting-list-box'>
                                    {user?.role?.name !== "admin" && user?.role?.name !== "employee" ? <li>
                                        <div className="form-check form-switch">
                                            <label className="form-check-label" htmlFor="flexSwitchCheckDefault">
                                                <i className="fa-regular fa-bell"></i> <span>Notification Setting</span>
                                            </label>

                                            <input className="form-check-input" value={notification} onChange={handleToggle} type="checkbox" role="switch" id="flexSwitchCheckDefault" checked={notification} />
                                        </div>
                                    </li> : ""}

                                    {/* <li className={changeCards === "Profile" ? "active-setting-tab" : ""} onClick={() => setChangeCards("profile")}><i className="fa-regular fa-user"></i> <span>My Profile</span></li> */}

                                    <li className={changeCards === "changePassword" ? "active-setting-tab" : ""} onClick={() => setChangeCards("changePassword")}><i className="fas fa-unlock-alt"></i> <span>Change Password</span></li>

                                    <li className={changeCards === "support" ? "active-setting-tab" : ""} onClick={() => setChangeCards("support")}><i className="fas fa-headphones-alt"></i> <span>Support</span></li>

                                    {/* <li className={changeCards === "blocklist" ? "active-setting-tab" : ""} onClick={() => setChangeCards("blocklist")}><i className="fas fa-ban"></i> <span>Block List</span></li> */}
                                </ul>
                            </div>
                        </div>


                        {
                            (changeCards === "changePassword") ? <div className="col-xl-6 col-lg-6 col-md-8 mt-4">

                                <ChangePasswordForm />

                            </div> : (changeCards === "support") ? <div className="col-xl-6 col-lg-6 col-md-8 mt-4">
                                <div className="sample-setting-box">
                                    <h1 className='home-main-heading mb-4'>Support</h1>
                                    <h3 className='sub-heading'>I-Sit Corporation</h3>
                                    <p className='common-text text-align-contact'><i className="fa-solid fa-envelope mail-icon"></i> lorem@lorem.com</p>
                                    <DownloadButtons />
                                </div>
                            </div> : (changeCards === "blocklist") ? <div className="col-xl-6 col-lg-6 col-md-8 mt-4">
                                <div className="sample-setting-box">
                                    <h1 className='home-main-heading mb-4'>Block List</h1>

                                    <div className="block-user-list">
                                        <span>John Doe</span>
                                        <a href="#">Unblock</a>
                                    </div>

                                    <div className="block-user-list">
                                        <span>John Doe</span>
                                        <a href="#">Unblock</a>
                                    </div>

                                    <div className="block-user-list">
                                        <span>John Doe</span>
                                        <a href="#">Unblock</a>
                                    </div>
                                </div>
                            </div> : (changeCards === "profile") ? <div className='col-md-12 mt-4'>
                                <div className='profile-detail-box'>
                                    <div className="text-icon-show">
                                        <div className="icon">
                                            <i className="fa-regular fa-user"></i>
                                        </div>

                                        <div className='profile-text-box'>
                                            <p>Company Name</p>
                                            <h3>Albert Flores</h3>
                                        </div>
                                    </div>

                                    <div className="text-icon-show">
                                        <div className="icon">
                                            <i className="fa-solid fa-envelope"></i>
                                        </div>

                                        <div className='profile-text-box'>
                                            <p>Email Address</p>
                                            <h3>admin@gmail.com</h3>
                                        </div>
                                    </div>

                                    <div className="text-icon-show">
                                        <div className="icon">
                                            <i className="fa-solid fa-location-crosshairs"></i>
                                        </div>

                                        <div className='profile-text-box'>
                                            <p>Location</p>
                                            <h3>123 New York</h3>
                                        </div>
                                    </div>

                                    <div className="text-icon-show">
                                        <div className="icon">
                                            <i className="fa-solid fa-phone-volume"></i>
                                        </div>

                                        <div className='profile-text-box'>
                                            <p>Phone Number</p>
                                            <h3>+92343443112</h3>
                                        </div>
                                    </div>

                                    <div className="text-icon-show">
                                        <div className="icon">
                                            <i className="fa-solid fa-briefcase"></i>
                                        </div>

                                        <div className='profile-text-box'>
                                            <p>Company EIN Number</p>
                                            <h3>004-998-998</h3>
                                        </div>
                                    </div>

                                    {/* <div className="text-icon-show">
                                        <div className="icon">

                                        </div>

                                        <div className='profile-text-box'>
                                            <p>POC Name</p>
                                            <h3>Lorem Company</h3>
                                        </div>

                                        <div className='profile-text-box ms-4'>
                                            <p>SSN Number</p>
                                            <h3>004-998-998</h3>
                                        </div>

                                        <div className='profile-text-box ms-4'>

                                        </div>
                                    </div> */}

                                    <div className="text-icon-show">
                                        <div className="icon">
                                            <i className="fa-solid fa-address-card"></i>
                                        </div>

                                        <div className='profile-text-box'>
                                            <p>About Comapny</p>
                                            <h3>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Dolorem, nisi.</h3>
                                        </div>
                                    </div>

                                    <div className="profile-image-box">
                                        <img src="/images/user.png" alt="" />
                                    </div>

                                </div>
                            </div> : ""
                        }
                    </div>
                </div>
            </div>
        </>
    )
}

export default AllSettings